// Foundations
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

// Models
import { ParsedBooking } from '@app/models/booking.model';

// Services
import { AnalyticsService } from '@app/services/analytics.service';
import { BookingService } from '@app/services/booking.service';

@Component({
  selector: 'app-bookings-tile',
  templateUrl: './bookings-tile.component.html',
  styleUrls: ['./bookings-tile.component.scss'],
})
export class BookingsTileComponent implements OnInit {
  @Input() booking: ParsedBooking;

  constructor(
    private router: Router,
    public bookingService: BookingService,
    private _analytics: AnalyticsService
  ) {}

  ngOnInit() {}

  cancelBooking() {
    this._analytics.logButtonTap('upcomingBooking_changeCancel');
    this.bookingService.selectedBooking = this.booking;
    this.router.navigate(['/upcoming-bookings/cancel'], {
      queryParams: { isChange: true },
    });
  }

  viewBookingDetails() {
    this._analytics.logButtonTap('upcomingBooking_viewDetails');
    this.bookingService.selectedBooking = this.booking;
    this.router.navigate(['/upcoming-bookings/view']);
  }
}
